export default "__VITE_ASSET__Bv4PFcNQ__"